<script>
  import { LoadingBarValue, InsightsRadioCheck } from "../../store.js";

  function loadingBarColor() {
    if ($InsightsRadioCheck == "SP") {
      return "#45bcbb";
    } else if ($InsightsRadioCheck == "OZP") {
      return "#0a6a5b";
    } else {
      return "#D9484D";
    }
  }
</script>

{#if ($LoadingBarValue < 100) & ($LoadingBarValue > 0)}
  <div class="progress-bar-container">
    <h5 style="position: absolute;top:-40px">Calculating Results...</h5>
    <div
      class="progress-bar"
      style="background-color:{loadingBarColor()};width: {$LoadingBarValue}%"
    ></div>
    <div style="position:absolute;opacity:{$LoadingBarValue == 0 ? 0 : 1}">
      {$LoadingBarValue}%
    </div>
  </div>
{/if}

<style>
  .progress-bar-container {
    position: absolute;
    width: 100%;
    z-index: 1000000;
    border: 2px solid white;
    top: 125px;
    left: -100px;
    border-radius: 10px;
  }

  .progress-bar {
    position: relative;
    height: 20px;

    width: 0;

    border-radius: 5px;
    transition: width 0.3s ease-in-out;
  }
</style>
